import { styled } from "@mui/material/styles";
import { AutocompleteInput } from "react-admin";
import DisableHandleKeyDown from "./DisableHandleKeyDown";
const CustomBeforeAutocompleteInput = styled(AutocompleteInput)(
  ({ theme }) => ({
    marginLeft: "20px",
    "& .MuiInputBase-root::before": {
      content: '"and"',
      fontSize: "12px",
      display: "block",
      height: "30px",
      width: "30px",
      marginLeft: "-30px",
    },
    width: "260px",
    "& .MuiAutocomplete-clearIndicator": {
      display: "none",
    },
  })
);

const BeforeAutocompleteInput = ({ ...props }) => {
  return (
    <CustomBeforeAutocompleteInput
      {...props}
      variant={
        props?.variant && props.variant.trim() !== ""
          ? props.variant
          : "outlined"
      }
      onKeyDown={(event: any) => {
        DisableHandleKeyDown(event);
      }}
    />
  );
};
export default BeforeAutocompleteInput;
